import { render, staticRenderFns } from "./IconLink.vue?vue&type=template&id=aaea2ba0&scoped=true"
import script from "./IconLink.vue?vue&type=script&lang=js"
export * from "./IconLink.vue?vue&type=script&lang=js"
import style0 from "./IconLink.vue?vue&type=style&index=0&id=aaea2ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaea2ba0",
  null
  
)

export default component.exports